import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9aa728ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center h-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn navbar-toggler mxa-navbar-menu-button",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#offcanvasNavbar",
  "aria-expanded": "false",
  "aria-controls": "offcanvasNavbar"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon mxa-navbar-menu-icon" })
], -1))
const _hoisted_3 = {
  class: "offcanvas offcanvas-end mxa-navbar-menu-offcanvas",
  tabindex: "-1",
  id: "offcanvasNavbar",
  "aria-labelledby": "offcanvasNavbarLabel"
}
const _hoisted_4 = { class: "offcanvas-header" }
const _hoisted_5 = {
  class: "offcanvas-title mxa-navbar-menu-offcanvas-header",
  id: "offcanvasNavbarLabel"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "closeMenu",
  type: "button",
  class: "btn-close text-reset",
  "data-bs-dismiss": "offcanvas"
}, null, -1))
const _hoisted_7 = { class: "offcanvas-body px-0" }
const _hoisted_8 = { class: "navbar-nav justify-content-end flex-grow-1 mxa-navbar-menu-offcanvas-body" }
const _hoisted_9 = { class: "nav-item mxa-navbar-logout" }

import { useRouter } from 'vue-router'
import { useMenu } from '@/model/components/menu/sideMenu'
import { buttonClick } from '@/model/util/dom/domUtil'
import { useStore } from '@/store'
import { logout } from '@/model/components/users/userLogout'
import * as log from '@/model/util/log/Logger'

// 状態

export default /*#__PURE__*/_defineComponent({
  __name: 'TheHeaderMenu',
  setup(__props) {

const store = useStore()
const router = useRouter()
const { isSelected, MENU_LIST } = useMenu(store)

// メニュークリック処理
const close = () => {
  // ボタンをクリックする事によりメニューを閉じる
  buttonClick('closeMenu')
}
// ログアウトボタン押下処理
const onclickLogout = () => {
  log.trace(`TheHeaderMenu onclickLogout start.`)
  // ログアウト処理を実施してTOP画面に遷移する(正常・異常に関わらず)
  logout(store, router)
  close()
  log.trace(`TheHeaderMenu onclickLogout end.`)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t('body.menu.title')), 1),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MENU_LIST), (data) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "nav-item",
              key: data.name
            }, [
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, {
                  to: data.routerName,
                  class: _normalizeClass(["nav-link mxa-navbar-menu-offcanvas-body-item ps-3", { 'mxa-navbar-menu-offcanvas-body-item-active': _unref(isSelected)(data.name) }]),
                  onClick: close,
                  "data-test": "link"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(data.resourcekey)), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "class"])
              ])
            ]))
          }), 128)),
          _createElementVNode("li", _hoisted_9, [
            _createElementVNode("button", {
              type: "button",
              class: "btn nav-link mxa-navbar-logout-item ps-3",
              onClick: onclickLogout,
              "data-test": "logout"
            }, _toDisplayString(_ctx.$t('body.menu.logout.title')), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})